export default "__VITE_ASSET__D21k6gE3__"